<div class="app-status-indicator {{ colorClass }}"></div>
